import React from 'react';
import Formsy from 'formsy-react';
import ReactHoverObserver from 'react-hover-observer';
import Checkbox from '../form/FormsyCheckbox';
import SVGChevron from '../../svg/Chevron';

class FilterBar extends React.Component {
  state = {
    openFilter: ''
  };

  render() {
    const { availableFilters, includeFormsy } = this.props;
    const filters = (
      <div className="filters">
        <p className="p filters__label">Filter by:</p>
        {Object.entries(availableFilters).map(filter =>
          this.renderSections(filter)
        )}
      </div>
    );

    return this.renderForm(includeFormsy, filters);
  }

  renderForm(includeFormsy = true, content) {
    return includeFormsy ? <Formsy>{content}</Formsy> : content;
  }

  renderSections([type, section]) {
    const classes =
      type === this.state.openFilter
        ? 'filter__options filter__options--open'
        : 'filter__options';

    return (
      <div
        key={type}
        className="filter-section a--blue"
        onClick={() => this.handleSectionChange(type)}
      >
        <ReactHoverObserver
          onHoverChanged={this.handleHoverChanged}
          hoverOffDelayInMs={250}
        >
          <div className="filter-section__label-group">
            <div className="filter-section__label">{section.label}</div>
            <div className="filter-section__icon">
              <SVGChevron />
            </div>
          </div>
          <div className={classes}>{this.renderOptions(type, section)}</div>
        </ReactHoverObserver>
      </div>
    );
  }

  renderOptions(type, section) {
    const { activeFilters, toggleFilter, swapFilter } = this.props;

    return section.options.map(option => {
      const key = `${type}:${option.id}`;
      const curFilter = {
        key,
        type,
        id: option.id,
        typeLabel: section.label,
        option: option.value,
        optionLabel:
          'prefix' in section
            ? section.prefix + option[section.prop]
            : option[section.prop]
      };

      const onChange =
        section.type === 'radio'
          ? () => swapFilter(curFilter)
          : () => toggleFilter(curFilter);

      const isChecked =
        activeFilters.findIndex(filter => filter.key === curFilter.key) > -1;
      return (
        <div key={key}>
          <Checkbox
            classes="filter__option"
            name={key}
            checked={isChecked}
            placeholder={curFilter.optionLabel}
            onChange={onChange}
          />
        </div>
      );
    });
  }

  handleHoverChanged = ({ isHovering }) => {
    if (this.state.openFilter !== '' && !isHovering)
      this.setState({ openFilter: '' });
  };

  handleSectionChange = section => {
    const openFilter = this.state.openFilter === section ? '' : section;
    this.setState({ openFilter });
  };
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/shared/FilterBar.js